import "lazysizes";
import Swup from "swup";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";

// import Lightbox from "./components/lightbox";

window.main = window.main || {};

let isTouchDevice = false;
let workFilterRequestId = 0;
let footerBnScrubAbort = null;
let researchParallaxAbort = null;
// let homeFeaturedBlurAbort = null;

function checks() {
  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

}

// function init() {
//   if (document.body.classList.contains("page-project")) {
//     new Lightbox({
//       selector: '[data-rel="aiLightbox"]',
//       lazyload: true,
//       arrows: true,
//       counter: true,
//       slideSpeed: 500,
//     });
//   }
// }

function updateWorkFilterStateFromUrl(filters, url) {
  const currentUrl = new URL(url, window.location.origin);
  const activeTypology = currentUrl.searchParams.get("typology");

  filters.forEach((filter) => {
    const filterUrl = new URL(filter.href, window.location.origin);
    const filterTypology = filterUrl.searchParams.get("typology");
    const isActive =
      (activeTypology && filterTypology === activeTypology) ||
      (!activeTypology && !filterTypology);

    filter.classList.toggle("is-active", isActive);
    if (isActive) {
      filter.setAttribute("aria-current", "page");
    } else {
      filter.removeAttribute("aria-current");
    }
  });
}

function getCssDurationMs(variable, fallbackMs) {
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
  const seconds = parseFloat(raw);
  return Number.isFinite(seconds) ? seconds * 1000 : fallbackMs;
}

function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function clamp01(value) {
  return Math.min(1, Math.max(0, value));
}

function initFooterBnScrub() {
  footerBnScrubAbort?.abort();
  footerBnScrubAbort = null;

  const footer = document.querySelector(".c-site-footer");
  const track = footer?.querySelector("[data-footer-bn-scrub]");
  const sticky = track?.querySelector(".c-site-footer__bn-sticky");
  if (!footer || !track || !sticky) return;

  footer.classList.remove("js-bn-scrub", "is-bn-scrub-static");
  footer.style.removeProperty("--bn-scale");
  footer.style.removeProperty("--footer-bn-sticky-height");

  const mq = window.matchMedia("(max-width: 768px)");
  // Inverted scrub: full size → compact while sticky.
  const endScale = 0.22;

  const setStaticEnd = () => {
    footer.classList.remove("js-bn-scrub");
    footer.classList.add("is-bn-scrub-static");
    footer.style.removeProperty("--footer-bn-sticky-height");
    footer.style.setProperty("--bn-scale", String(endScale));
  };

  const setScrubScale = (progress) => {
    const t = clamp01(progress);
    // 1 → endScale as scrub progresses
    const scale = 1 + (endScale - 1) * t;
    footer.style.setProperty("--bn-scale", scale.toFixed(4));
  };

  if (prefersReducedMotion()) {
    setStaticEnd();
    return;
  }

  footerBnScrubAbort = new AbortController();
  const { signal } = footerBnScrubAbort;
  let ticking = false;

  const update = () => {
    ticking = false;

    if (!mq.matches) {
      footer.classList.remove("js-bn-scrub", "is-bn-scrub-static");
      footer.style.removeProperty("--bn-scale");
      footer.style.removeProperty("--footer-bn-sticky-height");
      return;
    }

    footer.classList.add("js-bn-scrub");
    footer.classList.remove("is-bn-scrub-static");

    // Measure after scrub styles apply so padding-bottom inset is included.
    const stickyHeight = sticky.offsetHeight;
    footer.style.setProperty(
      "--footer-bn-sticky-height",
      `${Math.max(1, stickyHeight)}px`
    );

    // Travel of sticky inside compact track (letter row + ::after scrub range).
    const trackHeight = track.offsetHeight;
    const range = Math.max(1, trackHeight - sticky.offsetHeight);
    const traveled =
      sticky.getBoundingClientRect().top - track.getBoundingClientRect().top;
    const progress = clamp01(traveled / range);
    setScrubScale(progress);
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener("scroll", requestUpdate, { passive: true, signal });
  window.addEventListener("resize", requestUpdate, { passive: true, signal });
  if (mq.addEventListener) {
    mq.addEventListener("change", requestUpdate, { signal });
  } else {
    mq.addListener(requestUpdate);
    signal.addEventListener("abort", () => mq.removeListener(requestUpdate));
  }

  // Sync first paint (large at start of scrub).
  update();
}

function wait(ms) {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

function waitForOpacityTransition(
  element,
  durationVar = "--anim-speed-fade-in",
  fallbackMs = 400
) {
  const duration = getCssDurationMs(durationVar, fallbackMs);

  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      element.removeEventListener("transitionend", onEnd);
      resolve();
    };
    const onEnd = (event) => {
      if (event.target !== element || event.propertyName !== "opacity") return;
      finish();
    };

    element.addEventListener("transitionend", onEnd);
    window.setTimeout(finish, duration + 50);
  });
}

async function fadeWorkGridOut(grid) {
  if (!grid || prefersReducedMotion()) return;

  grid.classList.add("is-work-filter-fading");
  await waitForOpacityTransition(grid, "--anim-speed-fade-out", 220);
  await wait(getCssDurationMs("--anim-pause-page-transition", 120));
}

async function fadeWorkGridIn(grid) {
  if (!grid || prefersReducedMotion()) return;

  grid.classList.add("is-work-filter-fading");
  grid.offsetHeight;
  await new Promise((resolve) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(resolve);
    });
  });
  grid.classList.remove("is-work-filter-fading");
  await waitForOpacityTransition(grid, "--anim-speed-fade-in", 400);
}

async function replaceWorkGridFromUrl(url) {
  const requestId = ++workFilterRequestId;
  const currentGrid = document.querySelector(".c-work__grid");
  const fetchPromise = fetch(url, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Accept: "text/html,application/xhtml+xml",
    },
  });

  await fadeWorkGridOut(currentGrid);
  if (requestId !== workFilterRequestId) {
    currentGrid?.classList.remove("is-work-filter-fading");
    return;
  }

  const response = await fetchPromise;

  if (!response.ok) {
    throw new Error(`Work filter request failed: ${response.status}`);
  }

  const html = await response.text();
  if (requestId !== workFilterRequestId) return;

  const parsedDocument = parseDocumentFromHtml(html);
  const nextGrid = parsedDocument?.querySelector(".c-work__grid");

  if (!currentGrid || !nextGrid) return;

  currentGrid.replaceWith(nextGrid);
  if (requestId !== workFilterRequestId) {
    nextGrid.classList.remove("is-work-filter-fading");
    return;
  }

  await fadeWorkGridIn(nextGrid);
  initProjectsCardSiblingsHoverFade();
  initWorkGridReveal();
}

function closeWorkFiltersPanel() {
  const wrap = document.querySelector(".c-work__filters-wrap");
  if (!wrap || !wrap.classList.contains("is-open")) return;
  wrap.classList.remove("is-open");
  wrap.querySelector(".js-work-filters-fab")?.setAttribute("aria-expanded", "false");
}

function openWorkFiltersPanel(wrap) {
  wrap.classList.add("is-open");
  wrap.querySelector(".js-work-filters-fab")?.setAttribute("aria-expanded", "true");
}

function initWorkFiltersFab() {
  const wrap = document.querySelector(".c-work__filters-wrap");
  const fab = wrap?.querySelector(".js-work-filters-fab");
  if (!wrap || !fab) return;
  if (wrap.dataset.jsFiltersFabBound === "true") return;
  wrap.dataset.jsFiltersFabBound = "true";

  const mq = window.matchMedia("(max-width: 768px)");

  const onMqChange = () => {
    if (!mq.matches) {
      closeWorkFiltersPanel();
    }
  };

  if (mq.addEventListener) {
    mq.addEventListener("change", onMqChange);
  } else {
    mq.addListener(onMqChange);
  }

  fab.addEventListener("click", () => {
    if (!mq.matches) return;
    if (wrap.classList.contains("is-open")) {
      closeWorkFiltersPanel();
    } else {
      openWorkFiltersPanel(wrap);
    }
  });

  if (!window.main.workFiltersEscapeBound) {
    window.main.workFiltersEscapeBound = true;
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      if (document.body.dataset.mobNavOpen === "true") return;
      const activeWrap = document.querySelector(".c-work__filters-wrap.is-open");
      if (!activeWrap) return;
      closeWorkFiltersPanel();
      activeWrap.querySelector(".js-work-filters-fab")?.focus();
    });
  }
}

function initWorkFilters() {
  const workSection = document.querySelector(".c-work");
  const filtersRoot = workSection?.querySelector(".c-work__filters");
  if (!workSection || !filtersRoot) return;
  if (filtersRoot.dataset.jsBound === "true") return;

  const filters = Array.from(filtersRoot.querySelectorAll("a[href]"));
  if (!filters.length) return;

  const onFilterClick = async (event) => {
    const target = event.currentTarget;
    if (!(target instanceof HTMLAnchorElement)) return;

    event.preventDefault();
    event.stopPropagation();

    const nextUrl = target.href;
    if (nextUrl === window.location.href) {
      closeWorkFiltersPanel();
      return;
    }

    try {
      await replaceWorkGridFromUrl(nextUrl);
      window.history.pushState({}, "", nextUrl);
      updateWorkFilterStateFromUrl(filters, nextUrl);
    } catch (error) {
      window.location.href = nextUrl;
    } finally {
      closeWorkFiltersPanel();
    }
  };

  filters.forEach((filter) => {
    filter.addEventListener("click", onFilterClick);
  });

  if (!window.main.workFilterPopstateBound) {
    window.addEventListener("popstate", async () => {
      const activeFiltersRoot = document.querySelector(".c-work__filters");
      const activeFilters = activeFiltersRoot
        ? Array.from(activeFiltersRoot.querySelectorAll("a[href]"))
        : [];

      if (!activeFilters.length) return;

      try {
        await replaceWorkGridFromUrl(window.location.href);
        updateWorkFilterStateFromUrl(activeFilters, window.location.href);
      } finally {
        closeWorkFiltersPanel();
      }
    });
    window.main.workFilterPopstateBound = true;
  }

  updateWorkFilterStateFromUrl(filters, window.location.href);
  filtersRoot.dataset.jsBound = "true";
}

function initStudioIntroTypewriter() {
  const intro = document.querySelector(".c-studio__intro, .c-home__intro");
  if (!intro) return;
  if (intro.dataset.typewriterBound === "true") return;

  const sourceText = (intro.dataset.typewriterSource || intro.textContent || "")
    .replace(/^\s+|\s+$/g, "");
  if (!sourceText) return;
  intro.dataset.typewriterSource = sourceText;

  // Respect reduced motion preferences by keeping plain text.
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    intro.textContent = sourceText;
    intro.dataset.typewriterBound = "true";
    return;
  }

  intro.textContent = "";
  intro.setAttribute("aria-label", sourceText.replace(/\s+/g, " ").trim());

  const fragment = document.createDocumentFragment();
  let charIndex = 0;
  const stepMs = 26;

  const lines = sourceText.split("\n");

  lines.forEach((line, lineIndex) => {
    const tokens = line.match(/\S+|\s+/g) || [];

    tokens.forEach((token) => {
      if (/^\s+$/.test(token)) {
        fragment.appendChild(document.createTextNode(token));
        return;
      }

      const word = document.createElement("span");
      word.className = "c-studio__intro-word";
      word.setAttribute("aria-hidden", "true");

      Array.from(token).forEach((char) => {
        const span = document.createElement("span");
        span.className = "c-studio__intro-char";
        span.style.setProperty("--char-delay", `${charIndex * stepMs}ms`);
        span.setAttribute("aria-hidden", "true");
        span.textContent = char;
        word.appendChild(span);
        charIndex += 1;
      });

      fragment.appendChild(word);
    });

    if (lineIndex < lines.length - 1) {
      fragment.appendChild(document.createElement("br"));
    }
  });

  intro.appendChild(fragment);
  intro.dataset.typewriterBound = "true";
  intro.classList.remove("is-typing");

  window.requestAnimationFrame(() => {
    intro.classList.add("is-typing");
  });
}

function getScrollRevealRatio(item, viewportH) {
  const rect = item.getBoundingClientRect();
  if (rect.height <= 0) return 0;

  const visibleTop = Math.max(0, rect.top);
  const visibleBottom = Math.min(viewportH, rect.bottom);
  const visibleHeight = Math.max(0, visibleBottom - visibleTop);

  return visibleHeight / rect.height;
}

function getRevealStaggerDelay(index) {
  const stepMs = 20;
  const cycle = 3;
  return `${(index % cycle) * stepMs}ms`;
}

function revealScrollItem(item) {
  if (item.classList.contains("is-inview")) return;
  item.classList.add("is-inview");
}

function initScrollReveal({ container, itemSelector, bindAttr = "scrollRevealBound" }) {
  if (!container) return;
  if (container.dataset[bindAttr] === "true") return;

  container.dataset[bindAttr] = "true";

  const items = Array.from(container.querySelectorAll(itemSelector));
  if (!items.length) return;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
    .matches;

  document.body.classList.add("js-scroll-reveal-enabled");

  const viewportH = window.innerHeight || 0;

  const itemsToReveal = items.filter(
    (item) => getScrollRevealRatio(item, viewportH) < 0.35
  );

  itemsToReveal.forEach((item, index) => {
    item.style.setProperty("--reveal-delay", getRevealStaggerDelay(index));
    item.classList.add("is-pending-reveal");
  });

  if (reducedMotion) {
    itemsToReveal.forEach((item) => item.classList.add("is-inview"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealScrollItem(entry.target);
        obs.unobserve(entry.target);
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px 45% 0px",
    }
  );

  const earlyTriggerLine = viewportH * 1.45;

  itemsToReveal.forEach((item) => {
    observer.observe(item);

    const rect = item.getBoundingClientRect();
    if (rect.top < earlyTriggerLine && rect.bottom > 0) {
      revealScrollItem(item);
      observer.unobserve(item);
    }
  });
}

function initHomeFeaturedCardsReveal() {
  initScrollReveal({
    container: document.querySelector(".c-home-featured"),
    itemSelector: ".c-home-featured__link",
    bindAttr: "featuredRevealBound",
  });
}

/* Featured scroll blur (disabled — may restore)
function getFeaturedScrollBlurPx(rect, viewportH, maxBlur, blurZonePx) {
  if (rect.height <= 0) return 0;

  // Not reached yet
  if (rect.top >= viewportH) return 0;

  // Fully above the viewport
  if (rect.bottom <= 0) return maxBlur;

  // Sharp until the bottom edge is within blurZonePx of leaving the top
  if (rect.bottom > blurZonePx) return 0;

  const progress = 1 - rect.bottom / blurZonePx;
  return progress * maxBlur;
}

function initHomeFeaturedScrollBlur() {
  homeFeaturedBlurAbort?.abort();
  homeFeaturedBlurAbort = null;
  document.body.classList.remove("js-home-featured-scroll-blur");

  const container = document.querySelector(".c-home-featured");
  if (!container) return;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
    .matches;
  if (reducedMotion) return;

  const medias = Array.from(container.querySelectorAll(".c-home-featured__media"));
  if (!medias.length) return;

  homeFeaturedBlurAbort = new AbortController();
  const { signal } = homeFeaturedBlurAbort;
  const maxBlur = 18;
  const blurZonePx = 200;
  let ticking = false;

  document.body.classList.add("js-home-featured-scroll-blur");

  const update = () => {
    const viewportH = window.innerHeight || 0;

    medias.forEach((media) => {
      const blurPx = getFeaturedScrollBlurPx(
        media.getBoundingClientRect(),
        viewportH,
        maxBlur,
        blurZonePx
      );
      media.style.setProperty(
        "--featured-scroll-blur",
        blurPx > 0.25 ? `${blurPx.toFixed(2)}px` : "0px"
      );
    });

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener("scroll", requestUpdate, { passive: true, signal });
  window.addEventListener("resize", requestUpdate, { passive: true, signal });
  document.addEventListener("lazyloaded", requestUpdate, { passive: true, signal });

  requestUpdate();
}
*/

function initWorkGridReveal() {
  initScrollReveal({
    container: document.querySelector(".c-work__grid"),
    itemSelector: ".c-project-card",
    bindAttr: "gridRevealBound",
  });
}

function initResearchListReveal() {
  initScrollReveal({
    container: document.querySelector(".c-research-list"),
    itemSelector: ".c-research-list__item-body",
    bindAttr: "researchRevealBound",
  });
}

function initResearchCardParallax() {
  researchParallaxAbort?.abort();
  researchParallaxAbort = null;

  const list = document.querySelector(".c-research-list");
  if (!list) return;

  const mq = window.matchMedia(
    "(hover: hover) and (pointer: fine) and (min-width: 640px)"
  );
  if (prefersReducedMotion() || !mq.matches) return;

  const cards = Array.from(list.querySelectorAll(".c-research-list__item"));
  if (!cards.length) return;

  researchParallaxAbort = new AbortController();
  const { signal } = researchParallaxAbort;
  const maxPct = 5.5;
  const ease = 0.12; // lower = smoother / more lag
  const settle = 0.02;

  cards.forEach((card) => {
    const thumb = card.querySelector(".c-research-list__thumb");
    if (!thumb) return;

    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;
    let rafId = 0;
    let active = false;

    const apply = () => {
      thumb.style.setProperty("--research-parallax-x", currentX.toFixed(3));
      thumb.style.setProperty("--research-parallax-y", currentY.toFixed(3));
    };

    const stopLoop = () => {
      if (!rafId) return;
      window.cancelAnimationFrame(rafId);
      rafId = 0;
    };

    const tick = () => {
      currentX += (targetX - currentX) * ease;
      currentY += (targetY - currentY) * ease;

      if (
        Math.abs(targetX - currentX) < settle &&
        Math.abs(targetY - currentY) < settle
      ) {
        currentX = targetX;
        currentY = targetY;
        apply();
        rafId = 0;
        if (!active && currentX === 0 && currentY === 0) {
          card.classList.remove("is-parallaxing");
        }
        return;
      }

      apply();
      rafId = window.requestAnimationFrame(tick);
    };

    const startLoop = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(tick);
    };

    card.addEventListener(
      "pointerenter",
      (event) => {
        if (event.pointerType && event.pointerType !== "mouse") return;
        if (!mq.matches || prefersReducedMotion()) return;
        active = true;
        card.classList.add("is-parallaxing");
      },
      { signal }
    );

    card.addEventListener(
      "pointermove",
      (event) => {
        if (event.pointerType && event.pointerType !== "mouse") return;
        if (!mq.matches || prefersReducedMotion()) {
          active = false;
          targetX = 0;
          targetY = 0;
          startLoop();
          return;
        }

        const rect = card.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return;

        const nx = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        const ny = ((event.clientY - rect.top) / rect.height - 0.5) * 2;

        active = true;
        card.classList.add("is-parallaxing");
        targetX = Math.max(-1, Math.min(1, nx)) * maxPct;
        targetY = Math.max(-1, Math.min(1, ny)) * maxPct;
        startLoop();
      },
      { passive: true, signal }
    );

    card.addEventListener(
      "pointerleave",
      () => {
        active = false;
        targetX = 0;
        targetY = 0;
        startLoop();
      },
      { signal }
    );

    signal.addEventListener("abort", () => {
      stopLoop();
      active = false;
      targetX = 0;
      targetY = 0;
      currentX = 0;
      currentY = 0;
      apply();
      card.classList.remove("is-parallaxing");
    });
  });
}

function isMobileNavVisible(overlay) {
  return Boolean(
    overlay &&
      (overlay.classList.contains("is-open") ||
        document.body.dataset.mobNavOpen === "true" ||
        !overlay.hasAttribute("hidden"))
  );
}

function getScrollbarWidth() {
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

function lockBodyScroll() {
  // Prefer CSS scrollbar-gutter when supported; otherwise pad by classic scrollbar width.
  const scrollbarWidth =
    typeof CSS !== "undefined" && CSS.supports?.("scrollbar-gutter", "stable")
      ? 0
      : getScrollbarWidth();
  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${scrollbarWidth}px`
  );
  document.body.classList.add("no-scroll");
}

function unlockBodyScroll() {
  document.body.classList.remove("no-scroll");
  document.documentElement.style.removeProperty("--scrollbar-width");
}

async function closeMobileNavOverlay({
  focusToggle = true,
  instant = false,
} = {}) {
  const overlay = document.querySelector(".js-mob-nav-overlay");
  const toggle = document.querySelector(".js-mob-nav-toggle");
  const closeBtn = document.querySelector(".js-mob-nav-close");
  const brand = document.querySelector(".c-site-header__brand");
  if (!overlay || !isMobileNavVisible(overlay)) return;
  if (overlay.dataset.mobNavClosing === "true") return;

  overlay.dataset.mobNavClosing = "true";
  brand?.classList.remove("is-mob-typing");
  overlay.classList.remove("is-mob-typing");
  // Glyph swap is CSS on data-mob-nav-open (both SVGs stay in the toggle).
  delete document.body.dataset.mobNavOpen;
  unlockBodyScroll();
  closeBtn?.setAttribute("hidden", "");
  toggle?.setAttribute("aria-expanded", "false");
  toggle?.setAttribute("aria-label", "Open menu");
  overlay.classList.remove("is-open");
  overlay.setAttribute("aria-hidden", "true");

  if (!instant && !prefersReducedMotion()) {
    await waitForOpacityTransition(overlay, "--anim-speed-fade", 400);
  }

  overlay.setAttribute("hidden", "");
  delete overlay.dataset.mobNavClosing;

  if (
    focusToggle &&
    toggle &&
    (document.activeElement === closeBtn ||
      document.activeElement === toggle ||
      overlay.contains(document.activeElement))
  ) {
    toggle.focus();
  }
}

/* Overlay open typewriter step/fade stay at 26/70 via PHP + CSS */
const MOB_INTRO_REVERSE_STEP_MS = 36; /* ~1.4× of 26ms */
const MOB_INTRO_CHAR_FADE_MS = 100; /* ~1.4× of 70ms */
const MOB_INTRO_HOLD_MS = 1000;
/** Matches CSS: 0.2s delay + 1s opacity/visibility on intro reveal */
const MOB_INTRO_REVEAL_MS = 1200;

function isMobileIntroActive() {
  return document.documentElement.classList.contains("is-mob-intro");
}

function settleMobileIntro() {
  const html = document.documentElement;
  const brand = document.querySelector(".c-site-header__brand");
  const main = document.querySelector("#main");
  const footer = document.querySelector(".c-site-footer");
  const toggle = document.querySelector(".js-mob-nav-toggle");

  // Revealing class scopes the slow delayed fade; done persists for Swup soft navs.
  html.classList.add("is-mob-intro-done", "is-mob-intro-revealing");
  window.requestAnimationFrame(() => {
    brand?.classList.remove("is-mob-intro-untyping");
    html.classList.remove("is-mob-intro");

    main?.removeAttribute("aria-hidden");
    footer?.removeAttribute("aria-hidden");
    toggle?.removeAttribute("aria-hidden");
    toggle?.removeAttribute("tabindex");

    if (!document.body.dataset.mobNavOpen) {
      unlockBodyScroll();
    }

    const clearRevealing = () => {
      html.classList.remove("is-mob-intro-revealing");
    };

    if (prefersReducedMotion() || !main) {
      clearRevealing();
      return;
    }

    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      main.removeEventListener("transitionend", onEnd);
      clearRevealing();
    };
    const onEnd = (event) => {
      if (event.target !== main || event.propertyName !== "opacity") return;
      finish();
    };

    main.addEventListener("transitionend", onEnd);
    window.setTimeout(finish, MOB_INTRO_REVEAL_MS + 50);
  });

  // In-memory only — blocks Swup soft navs from replaying; hard refresh re-runs via head bootstrap.
  window.main.mobIntroDone = true;
}

/**
 * Mobile-only brand intro on every hard page load/refresh.
 * Skipped on Swup soft navigations via html.is-mob-intro-done / window.main.mobIntroDone (no storage).
 */
async function initMobileIntro() {
  const html = document.documentElement;

  if (html.classList.contains("is-mob-intro-done") || window.main.mobIntroDone) {
    html.classList.remove("is-mob-intro");
    html.classList.add("is-mob-intro-done");
    return;
  }

  if (!html.classList.contains("is-mob-intro")) {
    html.classList.add("is-mob-intro-done");
    return;
  }

  const mq = window.matchMedia("(max-width: 768px)");
  if (!mq.matches || prefersReducedMotion()) {
    settleMobileIntro();
    return;
  }

  const brand = document.querySelector(".c-site-header__brand");
  const chars = brand
    ? brand.querySelectorAll(".c-site-header__brand-mob-ch")
    : [];
  if (!brand || !chars.length) {
    settleMobileIntro();
    return;
  }

  const main = document.querySelector("#main");
  const footer = document.querySelector(".c-site-footer");
  const toggle = document.querySelector(".js-mob-nav-toggle");

  lockBodyScroll();
  main?.setAttribute("aria-hidden", "true");
  footer?.setAttribute("aria-hidden", "true");
  toggle?.setAttribute("aria-hidden", "true");
  toggle?.setAttribute("tabindex", "-1");

  const abortOnDesktop = () => {
    if (!mq.matches) settleMobileIntro();
  };
  mq.addEventListener("change", abortOnDesktop);

  try {
    await wait(MOB_INTRO_HOLD_MS);
    if (!isMobileIntroActive() || !mq.matches) return;

    brand.classList.add("is-mob-intro-untyping");
    const untypeMs =
      Math.max(0, chars.length - 1) * MOB_INTRO_REVERSE_STEP_MS +
      MOB_INTRO_CHAR_FADE_MS +
      40;
    await wait(untypeMs);
    if (!isMobileIntroActive()) return;

    settleMobileIntro();
  } finally {
    mq.removeEventListener("change", abortOnDesktop);
  }
}

function initMobileNav() {
  const toggle = document.querySelector(".js-mob-nav-toggle");
  const overlay = document.querySelector(".js-mob-nav-overlay");
  const closeBtn = document.querySelector(".js-mob-nav-close");
  const brand = document.querySelector(".c-site-header__brand");
  if (!toggle || !overlay || !closeBtn) return;
  if (overlay.dataset.mobNavBound === "true") return;
  overlay.dataset.mobNavBound = "true";

  const mq = window.matchMedia("(max-width: 768px)");

  const clearMobNavTyping = () => {
    brand?.classList.remove("is-mob-typing");
    overlay.classList.remove("is-mob-typing");
  };

  const startMobNavTyping = () => {
    clearMobNavTyping();
    if (prefersReducedMotion()) {
      brand?.classList.add("is-mob-typing");
      overlay.classList.add("is-mob-typing");
      return;
    }
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        brand?.classList.add("is-mob-typing");
        overlay.classList.add("is-mob-typing");
      });
    });
  };

  const close = () => closeMobileNavOverlay({ focusToggle: true });

  const open = () => {
    if (isMobileIntroActive()) return;
    if (overlay.classList.contains("is-open") || overlay.dataset.mobNavClosing === "true") {
      return;
    }

    closeWorkFiltersPanel();
    document.body.dataset.mobNavOpen = "true";
    lockBodyScroll();
    overlay.removeAttribute("hidden");
    overlay.removeAttribute("aria-hidden");
    // Force a frame at opacity 0 so the fade-in can run.
    void overlay.offsetWidth;
    overlay.classList.add("is-open");
    // Visible +/− stay on the toggle (stacked). Keep the legacy close control hidden
    // so close never display:none-swaps a second glyph over the toggle.
    closeBtn.setAttribute("hidden", "");
    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute("aria-label", "Close menu");
    toggle.focus();
    startMobNavTyping();
  };

  overlay.setAttribute("aria-hidden", "true");

  const onToggleClick = () => {
    if (isMobileIntroActive()) return;
    if (overlay.dataset.mobNavClosing === "true") return;
    if (overlay.classList.contains("is-open") || document.body.dataset.mobNavOpen === "true") {
      close();
    } else {
      open();
    }
  };

  toggle.addEventListener("click", onToggleClick);
  closeBtn.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    close();
  });

  overlay.querySelectorAll("a[href]").forEach((link) => {
    link.addEventListener("click", close);
  });

  brand?.addEventListener("click", () => {
    if (isMobileIntroActive()) return;
    if (overlay.classList.contains("is-open") || document.body.dataset.mobNavOpen === "true") {
      close();
    }
  });

  if (!window.main.mobNavEscapeBound) {
    window.main.mobNavEscapeBound = true;
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      const activeOverlay = document.querySelector(".js-mob-nav-overlay");
      if (!isMobileNavVisible(activeOverlay)) return;
      closeMobileNavOverlay({ focusToggle: true });
    });
  }

  if (!window.main.mobNavMqBound) {
    window.main.mobNavMqBound = true;
    mq.addEventListener("change", () => {
      if (!mq.matches) {
        closeMobileNavOverlay({ focusToggle: false, instant: true });
      }
    });
  }
}

function initProjectsCardSiblingsHoverFade() {
  if (!document.body.classList.contains("page-projects")) return;
  if (isTouchDevice) return;

  const grid = document.querySelector(".c-work__grid");
  if (!grid) return;
  if (grid.dataset.siblingsHoverFadeBound === "true") return;
  grid.dataset.siblingsHoverFadeBound = "true";

  const cards = Array.from(grid.querySelectorAll(".c-project-card"));
  if (!cards.length) return;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
    .matches;

  let timeoutId = null;
  let isScrolling = false;
  let scrollEndTimer = null;
  const scrollCooldownMs = 180;

  const clearDim = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    grid.classList.remove("is-siblings-dimmed");
    cards.forEach((c) => c.classList.remove("is-active"));
  };

  const markScrolling = () => {
    isScrolling = true;
    clearDim();

    if (scrollEndTimer) clearTimeout(scrollEndTimer);
    scrollEndTimer = window.setTimeout(() => {
      isScrolling = false;
      scrollEndTimer = null;
    }, scrollCooldownMs);
  };

  window.addEventListener("wheel", markScrolling, { passive: true });
  window.addEventListener("scroll", markScrolling, { passive: true });

  const startDimTimer = (card) => {
    if (isScrolling) return;

    clearDim();

    if (reducedMotion) {
      grid.classList.add("is-siblings-dimmed");
      card.classList.add("is-active");
      return;
    }

    timeoutId = window.setTimeout(() => {
      if (isScrolling) return;

      grid.classList.add("is-siblings-dimmed");
      card.classList.add("is-active");
      timeoutId = null;
    }, 1000);
  };

  cards.forEach((card) => {
    card.addEventListener("mouseenter", (event) => {
      if (event.pointerType && event.pointerType !== "mouse") return;
      startDimTimer(card);
    });
    card.addEventListener("mouseleave", clearDim);
  });
}

function runPageSetup() {
  // Sync closed glyph (+) before paint; do not leave data-mob-nav-open across Swup replaces.
  delete document.body.dataset.mobNavOpen;
  // Keep scroll lock if the mobile brand intro is still running.
  if (!isMobileIntroActive()) {
    unlockBodyScroll();
  }
  document.querySelector(".c-site-header__brand")?.classList.remove("is-mob-typing");
  const overlay = document.querySelector(".js-mob-nav-overlay");
  if (overlay) {
    overlay.classList.remove("is-mob-typing", "is-open");
    overlay.setAttribute("hidden", "");
    overlay.setAttribute("aria-hidden", "true");
    delete overlay.dataset.mobNavClosing;
  }
  const toggle = document.querySelector(".js-mob-nav-toggle");
  toggle?.setAttribute("aria-expanded", "false");
  toggle?.setAttribute("aria-label", "Open menu");
  document.querySelector(".js-mob-nav-close")?.setAttribute("hidden", "");
  checks();
  initWorkFilters();
  initWorkFiltersFab();
  initStudioIntroTypewriter();
  initHomeFeaturedCardsReveal();
  // initHomeFeaturedScrollBlur();
  initWorkGridReveal();
  initResearchListReveal();
  initResearchCardParallax();
  initMobileNav();
  initMobileIntro();
  initFooterBnScrub();
  initProjectsCardSiblingsHoverFade();
}

function parseDocumentFromHtml(html) {
  if (!html) return null;
  return new DOMParser().parseFromString(html, "text/html");
}

function syncBodyAttributesFromDocument(nextDocument) {
  if (!nextDocument || !nextDocument.body) return;

  const nextBody = nextDocument.body;
  const nextView = nextBody.getAttribute("data-current-view");
  const nextStudioBg = nextBody.getAttribute("data-studio-bg");

  if (nextView) {
    document.body.setAttribute("data-current-view", nextView);
  } else {
    document.body.removeAttribute("data-current-view");
  }

  if (nextStudioBg) {
    document.body.setAttribute("data-studio-bg", nextStudioBg);
  } else {
    document.body.removeAttribute("data-studio-bg");
  }
}

function animateActiveNavLabel() {
  const nav = document.querySelector("#header .c-nav");
  if (!nav) return;

  nav.classList.remove("is-active-label-animating");
  window.requestAnimationFrame(() => {
    nav.classList.add("is-active-label-animating");
    window.setTimeout(() => {
      nav.classList.remove("is-active-label-animating");
    }, 600);
  });
}

runPageSetup();

if (document.querySelector("#main")) {
  const swup = new Swup({
    containers: ["#header", "#main"],
    animationSelector: "[data-transition='fade'], .transition-fade",
    plugins: [
      new SwupBodyClassPlugin({
        prefix: "page-",
        attributes: ["data-current-view", "data-studio-bg"],
      }),
      new SwupScrollPlugin({
        animateScroll: {
          betweenPages: false,
          samePageWithHash: true,
          samePage: true,
        },
      }),
    ],
  });

  swup.hooks.on("content:replace.before", (visit, { page }) => {
    const nextDocument = parseDocumentFromHtml(page?.html);
    syncBodyAttributesFromDocument(nextDocument);
  });

  swup.hooks.on("page:view", () => {
    runPageSetup();
    animateActiveNavLabel();
  });
}
